import axios from "axios";
import axiosRetry from "axios-retry";
import isNull from "../mixin/isNull";
import useIdpRepository from "../repository/auth/useIdpRepository";

export default function () {
    const idpRepository = useIdpRepository();

    axiosRetry(axios, {
        retries: 1,
        retryCondition: async e => {
            if (isNull(e?.response?.status)) return false;

            if (e.response.status === 401
                && e.response.config.url.includes(process.env.REACT_APP_API_URL)
                && !e.response.config.url.includes("/idp/session/refresh")) {
                const res = await idpRepository.refresh();

                if (res !== true) {
                    // refresh() a déjà redirigé si la session est réellement invalide (401/403).
                    // Sinon (erreur réseau au réveil), on ne déconnecte pas : on laisse l'erreur remonter.
                    console.warn("Token refresh failed, request not retried");
                    return false;
                }

                return true;
            }

            return false;
        },
        retryDelay: retryCount => 1000
    });
}
